import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import SolutionPage from "./pages/SolutionPage";
import InfoPage from "./pages/InfoPage";
import FloatingChat from "./components/FloatingChat";
import "./App.css";

function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash, pathname]);
  return null;
}

function SolutionRoute({ openChat }) {
  const { slug } = useParams();
  return <SolutionPage slug={slug} openChat={openChat} />;
}

function InfoRoute({ slug, openChat }) {
  return <InfoPage slug={slug} openChat={openChat} />;
}

function App() {
  const [chatOpen, setChatOpen] = useState(false);
  const openChat = () => setChatOpen(true);
  return (
    <div className="App min-h-screen bg-[#050816] text-white">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home openChat={openChat} />} />
          <Route path="/solutions/:slug" element={<SolutionRoute openChat={openChat} />} />
          <Route path="/about" element={<InfoRoute slug="about" openChat={openChat} />} />
          <Route path="/case-studies" element={<InfoRoute slug="case-studies" openChat={openChat} />} />
          <Route path="/careers" element={<InfoRoute slug="careers" openChat={openChat} />} />
          <Route path="/press" element={<InfoRoute slug="press" openChat={openChat} />} />
          <Route path="/privacy" element={<InfoRoute slug="privacy" openChat={openChat} />} />
          <Route path="/terms" element={<InfoRoute slug="terms" openChat={openChat} />} />
          <Route path="/dpa" element={<InfoRoute slug="dpa" openChat={openChat} />} />
          <Route path="/security" element={<InfoRoute slug="security" openChat={openChat} />} />
        </Routes>
        <FloatingChat open={chatOpen} setOpen={setChatOpen} />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
